import React from 'react';
import {
    PanelHeader,
    Div,
    Spinner,
    SplitCol,
    SplitLayout,
    Button, ButtonGroup
} from '@vkontakte/vkui';


import {AdaptivityContext, setQuizStep} from "../assets/constants";

import BaseComponent from "../components/BaseComponent";
import BaseApi from "../api/BaseApi";
import FacingMonitoringProducts from "./Products";

import FacingMonitoringStepHeader from "./StepHeader";
import * as constants from "../assets/constants";


class FacingMonitoringStep2 extends BaseComponent {

    state = {
        mainSearch: this.props.get_vars && this.props.get_vars.search !== undefined ? this.props.get_vars.search : '',
        doc_id: 'test-test-test',
        items: [],
        ids: [],
        codes: [],
        cnt_products: 0,
        loading: true
    }

    constructor(props) {
        super(props);
    }


    getItems = (sSearch = null) => {
        clearTimeout(this.searchInterval);

        this.setState({loading: true})

        BaseApi.post('?app=facingMonitoring&act=getDocItems', {
                doc_id: this.state.doc_id,
                sSearch: this.state.mainSearch,
                codes: this.state.codes.length > 0 ? JSON.stringify(this.state.codes) : '',
                ids: this.state.ids.length > 0 ? JSON.stringify(this.state.ids) : ''
            },
            {
                withCredentials: true

            }
        ).then((response) => {

            const items = JSON.parse(JSON.stringify(response.data.results))

            if (items && Array.isArray(items) && this.state.codes.length > 0) {

                 window.postMessage({type: 'IncrementFacingMonitoringValues', items: items.reverse()})
            }

            setTimeout(() => {
                this.setState({
                    loading: false,
                    items: response.data.results ?? [],
                    codes: [],
                    cnt_products: response.data.total
                })
                if (items && this.state.codes.length > 0) {
                    window.postMessage('startScan')
                }

            }, 1000)

        })
    }
    receiveMessage = (event) => {

       // console.log(event.data)
        if (event.data.type == 'FacingIdsChanged') {

            if (event.data.ids.length != this.state.ids.length) {
                this.setState({ids: event.data.ids})
            }
        }
        if (event.data.type == 'qrCodeArrived') {

            const e = {
                target: {
                    value: event.data.code + '$'
                }
            }
            this.onSearchChange(e, true)
            //window.postMessage({type: 'error', text: event.data.code, timeout: 20000})
        }

        if (event.data.type == 'qrCodesArrived') {
            const codes = event.data.codes;
           // window.postMessage({type: 'error', text: JSON.stringify(codes), timeout: 20000})
            this.setState({codes})
            setTimeout(() => this.getItems(), 1000)
        }
    }

    componentDidMount() {
        super.componentDidMount()
        const data = localStorage.getItem(constants.values_facing_monitoring_key)

        if (data && data !== "undefined") {
            const items = JSON.parse(data)

            console.log(items)
            const ids = Object.keys(items).sort((a, b) => items[b].sort - items[a].sort)
            //console.log(ids)
            this.setState({ids})
        }
        setTimeout(() =>
            this.getItems(), 700)
    }

    onSearchChange = (e, noWait = false) => {
        if (e.target.value == '' && this.props.get_vars && this.props.get_vars.search !== undefined) {

            window.postMessage('clearGetVarsSearch')

        }
        clearTimeout(this.searchInterval)
        this.setState({mainSearch: e.target.value})
        this.searchInterval = setTimeout(() => {
            clearTimeout(this.searchInterval)
            this.getItems(e.target.value)
        }, noWait ? 50 : 2000)
    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');

        return (
            <SplitLayout>
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Инвентаризация витрины. Шаг 2
                        </Div>
                    </PanelHeader>
                    <FacingMonitoringStepHeader onSearchChange={this.onSearchChange}
                                                search={this.state.mainSearch}
                                                step={1}/>
                    <SplitLayout>
                        <SplitCol>
                            {this.state.loading ? <Spinner size="large"/> : ''}
                            <FacingMonitoringProducts items={this.state.items}
                                                      search={this.state.mainSearch}
                                                      base_url={this.props.base_url}
                                                      images_url={images_url}
                                                      current_user={this.props.current_user}
                                                      current_doc={this.props.current_doc}/>
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div className="action-board">
                                <ButtonGroup mode="horizontal" stretched>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(1, 'FacingMonitoring')}>Назад</Button>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(3, 'FacingMonitoring')}>Далее</Button>
                                </ButtonGroup>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                </SplitCol>
            </SplitLayout>)
    }


}

export default FacingMonitoringStep2